import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_mt-a"
}
const _hoisted_2 = {
  key: 0,
  class: "_flex _ai-b _flexwrap"
}
const _hoisted_3 = {
  key: 0,
  class: "gfu-bt gfu-bt--caption _tc--lighter",
  "data-qa": "project-card:FundedAtText"
}
const _hoisted_4 = {
  key: 1,
  class: "gfu-bt gfu-bt--caption _tc--lighter"
}
const _hoisted_5 = {
  key: 1,
  class: "_flex _flexwrap _ai-b"
}
const _hoisted_6 = { class: "gfu-bt gfu-bt--caption _tc--lighter" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_currency_conversion_tooltip = _resolveComponent("currency-conversion-tooltip")
  const _component_display_currency_renderer = _resolveComponent("display-currency-renderer")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (!$options.isProjectV1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($options.showCrowdfundingOnlyFundsGathered)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(['gfu-hd gfu-hd--h3 _mr-1', {'_tc--inverse': $props.scheme === 'inverse'}]),
                "data-qa": "project-card:FundsGathered"
              }, [
                _createVNode(_component_display_currency_renderer, {
                  class: "_flexinline _ai-c _gap-1",
                  amount: $props.fundsGathered,
                  "source-currency-id": $props.currencyID,
                  "source-currency-symbol": $props.currencySymbol
                }, {
                  default: _withCtx(({ formattedOriginalAmount, formattedNativeAmount, isConverted }) => [
                    _createTextVNode(_toDisplayString(formattedOriginalAmount) + " ", 1 /* TEXT */),
                    isConverted
                      ? (_openBlock(), _createBlock(_component_currency_conversion_tooltip, {
                          key: 0,
                          "icon-classes": "gfu-icon--medium"
                        }, _createSlots({
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(formattedNativeAmount) + " ", 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, [
                          ($props.campaignGoal !== null)
                            ? {
                                name: "content",
                                fn: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($options.currencyConversionWithGoalTooltip), 1 /* TEXT */)
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1024 /* DYNAMIC_SLOTS */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["amount", "source-currency-id", "source-currency-symbol"])
              ], 2 /* CLASS */),
              ($props.showFundedAt && $options.fundedAtText)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.Homepage.ProjectCardFundingGoalReachedInCaption, $options.fundedAtText)) + " ", 1 /* TEXT */),
                    _createVNode(_component_tooltip, null, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.Homepage.ProjectCardFundingGoalPercentageTooltip, $props.fundsGatheredPercentage)), 1 /* TEXT */)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, { name: "circle-info" })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.Resources.Homepage.ProjectCardFundingAmountPledgedCaption), 1 /* TEXT */))
            ]))
          : ($options.showEverythingFundsGathered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(['gfu-hd gfu-hd--h3 _mr-1', {'_tc--inverse': $props.scheme === 'inverse'}]),
                  "data-qa": "project-card:FundsGathered"
                }, [
                  _createVNode(_component_display_currency_renderer, {
                    class: "_flexinline _ai-c _gap-1",
                    amount: $props.fundsGathered,
                    "source-currency-id": $props.currencyID,
                    "source-currency-symbol": $props.currencySymbol
                  }, {
                    default: _withCtx(({ formattedOriginalAmount, formattedNativeAmount, isConverted }) => [
                      _createTextVNode(_toDisplayString(formattedOriginalAmount) + " ", 1 /* TEXT */),
                      isConverted
                        ? (_openBlock(), _createBlock(_component_currency_conversion_tooltip, {
                            key: 0,
                            "icon-classes": "gfu-icon--medium"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formattedNativeAmount), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["amount", "source-currency-id", "source-currency-symbol"])
                ], 2 /* CLASS */),
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.ProjectCardFundingTotalCaption) + " ", 1 /* TEXT */),
                  _createVNode(_component_tooltip, null, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.ProjectCardFundingTotalTooltip), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, { name: "circle-info" })
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}